import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductListingQuickshipFilter from '../../ProductListingQuickshipFilter';
import MobileProductListingFilterWrapper from './MobileProductListingFilterWrapper';
import ProductListingColorFilter from '../../ProductListingColorFilter';
import MobileProductListingListFilter from './MobileProductListingListFilter';
import ProductListingWidthRangeFilter from '../../ProductListingWidthRangeFilter';
const MobileProductListingFilter = t0 => {
  const $ = _c(9);
  const {
    id,
    label
  } = t0;
  let t1;
  bb0: {
    if (id === "quickship") {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <ProductListingQuickshipFilter />;
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    if (id === "color") {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <ProductListingColorFilter />;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    if (id === "widthRange") {
      let t2;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <ProductListingWidthRangeFilter />;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[3] !== id) {
      t2 = <MobileProductListingListFilter id={id} />;
      $[3] = id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = t2;
  }
  let t2;
  if ($[5] !== id || $[6] !== label || $[7] !== t1) {
    t2 = <MobileProductListingFilterWrapper id={id} label={label}>{t1}</MobileProductListingFilterWrapper>;
    $[5] = id;
    $[6] = label;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
MobileProductListingFilter.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string
};
export default MobileProductListingFilter;